// extracted by mini-css-extract-plugin
export var productcolumn = "product-head-section-module--productcolumn--TGcll";
export var productcolumnwide = "product-head-section-module--productcolumnwide--tqe92";
export var productmainheader = "product-head-section-module--productmainheader--7xn3d";